/* ============================================
   BeeLive Studio — bee-product-card.js
   ============================================ */

(function () {
  'use strict';

  // ── Extraire le panier depuis l'event Savor ──────────
  // Savor peut envoyer detail.resource, detail.data, ou rien
  function extractCart(e) {
    return e.detail?.resource || e.detail?.data || null;
  }

  // ── Rafraîchir le panier Savor ───────────────────────
  function refreshCart() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { data: cart }
        }));
        // Synchro immédiate sans attendre l'event
        syncCardsWithCart(cart);
      })
      .catch(err => console.warn('BeeLive cart refresh:', err));
  }

  // ── Synchroniser toutes les cartes ───────────────────
  function syncCardsWithCart(cart) {
    if (!cart) return;

    const cartItems = {};
    const items = cart.items || cart.line_items || [];
    items.forEach(item => {
      cartItems[String(item.variant_id)] = item.quantity;
    });

    document.querySelectorAll('.bee-pcard').forEach(card => {
      const variantA = card.dataset.variantAdhesif;
      const variantP = card.dataset.variantPvc;

      let qtyInCart = 0;
      let isPvc = false;

      if (variantA && cartItems[variantA]) {
        qtyInCart = cartItems[variantA];
      } else if (variantP && cartItems[variantP]) {
        qtyInCart = cartItems[variantP];
        isPvc = true;
      }

      const badge = card.querySelector('.bee-pcard__cart-badge');
      const btn = card.querySelector('.bee-pcard__add-btn');

      if (qtyInCart > 0) {
        card.classList.add('bee-pcard--in-cart');
        if (badge) {
          badge.dataset.qty = String(qtyInCart);
          badge.textContent = qtyInCart > 1 ? `× ${qtyInCart} dans le panier` : '✓ Dans le panier';
        }
        if (btn && !btn.classList.contains('bee-pcard__add-btn--added')) {
          btn.style.background = '#C7801D';
        }
        if (isPvc) {
          card.querySelectorAll('.bee-pcard__fmt').forEach(f => f.classList.remove('bee-pcard__fmt--active'));
          const fmtPvc = card.querySelector('[data-format="pvc"]');
          if (fmtPvc) fmtPvc.classList.add('bee-pcard__fmt--active');
        }
      } else {
        card.classList.remove('bee-pcard--in-cart');
        if (badge) {
          badge.dataset.qty = '0';
          badge.textContent = '';
        }
        if (btn && !btn.classList.contains('bee-pcard__add-btn--added')) {
          btn.style.background = '';
        }
      }
    });
  }

  // ── Écouter les updates de Savor ─────────────────────
  document.addEventListener('cart:update', function (e) {
    const cart = extractCart(e);
    if (cart) {
      syncCardsWithCart(cart);
    } else {
      // Event sans data — refetch
      fetch('/cart.js').then(r => r.json()).then(syncCardsWithCart);
    }
  });

  // ── Restaurer au chargement ───────────────────────────
  function restoreCartState() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(syncCardsWithCart)
      .catch(err => console.warn('BeeLive restore cart:', err));
  }

  // ── Sélection de format ──────────────────────────────
  function selectFormat(fmtEl) {
    const card = fmtEl.closest('.bee-pcard');
    card.querySelectorAll('.bee-pcard__fmt').forEach(f => f.classList.remove('bee-pcard__fmt--active'));
    fmtEl.classList.add('bee-pcard__fmt--active');
  }

  // ── Quantité ─────────────────────────────────────────
  function changeQty(btnEl, dir) {
    const wrap = btnEl.closest('.bee-pcard__qty');
    const valEl = wrap.querySelector('.bee-pcard__qty-val');
    let n = parseInt(valEl.textContent) + dir;
    if (n < 1) n = 1;
    if (n > 99) n = 99;
    valEl.textContent = n;
  }

  // ── Ajout au panier ──────────────────────────────────
  function addToCart(btnEl) {
    const card = btnEl.closest('.bee-pcard');
    const qty = parseInt(card.querySelector('.bee-pcard__qty-val').textContent) || 1;
    const activeFmt = card.querySelector('.bee-pcard__fmt--active');
    const isPvc = activeFmt && activeFmt.dataset.format === 'pvc';
    const variantId = isPvc ? card.dataset.variantPvc : card.dataset.variantAdhesif;
    if (!variantId) return;

    btnEl.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId), quantity: qty })
    })
    .then(r => r.json())
    .then(() => {
      flashButton(btnEl, qty);
      refreshCart();
    })
    .catch(() => flashButton(btnEl, qty))
    .finally(() => { btnEl.disabled = false; });
  }

  // ── Flash bouton ─────────────────────────────────────
  function flashButton(btnEl, qty) {
    btnEl.textContent = qty > 1 ? `✓ ${qty} ajoutés !` : '✓ Ajouté !';
    btnEl.classList.add('bee-pcard__add-btn--added');
    setTimeout(() => {
      btnEl.textContent = 'Ajouter au panier';
      btnEl.classList.remove('bee-pcard__add-btn--added');
      const card = btnEl.closest('.bee-pcard');
      if (card && card.classList.contains('bee-pcard--in-cart')) {
        btnEl.style.background = '#C7801D';
      }
    }, 1800);
  }

  // ── Délégation d'événements ──────────────────────────
  document.addEventListener('click', function (e) {
    if (e.target.closest('.bee-pcard__fmt')) {
      selectFormat(e.target.closest('.bee-pcard__fmt')); return;
    }
    const qbtn = e.target.closest('.bee-pcard__qty-btn');
    if (qbtn && qbtn.closest('.bee-pcard')) {
      changeQty(qbtn, qbtn.dataset.dir === 'up' ? 1 : -1); return;
    }
    const addBtn = e.target.closest('.bee-pcard__add-btn');
    if (addBtn && addBtn.closest('.bee-pcard')) {
      addToCart(addBtn); return;
    }
  });

  // ── Flèches photo : interceptées en phase CAPTURE pour bloquer la lightbox ──
  document.addEventListener('click', function (e) {
    const imgArrow = e.target.closest('.bee-pcard__img-arrow');
    if (!imgArrow) return;
    e.preventDefault();
    e.stopPropagation();
    const wrap = imgArrow.closest('.bee-pcard__img');
    const imgs = (wrap.dataset.images || '').split('|').filter(Boolean);
    if (imgs.length > 1) {
      let idx = parseInt(wrap.dataset.imgIdx || '0', 10);
      idx += imgArrow.classList.contains('bee-pcard__img-arrow--next') ? 1 : -1;
      if (idx < 0) idx = imgs.length - 1;
      if (idx >= imgs.length) idx = 0;
      wrap.dataset.imgIdx = idx;
      const img = wrap.querySelector('img');
      if (img) { img.removeAttribute('srcset'); img.src = imgs[idx]; }
    }
  }, true); // ← le "true" = phase capture, c'est la clé

  // ── Init ─────────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', restoreCartState);
  } else {
    restoreCartState();
  }

  // ── Précharge les photos secondaires au premier survol de la carte ──
  function preloadCardImages(wrap) {
    if (!wrap || wrap.dataset.imgPreloaded === '1') return;
    wrap.dataset.imgPreloaded = '1';
    (wrap.dataset.images || '').split('|').filter(Boolean).slice(1).forEach(url => {
      const im = new Image();
      im.src = url;
    });
  }
  function onCardApproach(e) {
    if (!e.target || !e.target.closest) return;
    preloadCardImages(e.target.closest('.bee-pcard__img[data-images]'));
  }
  document.addEventListener('mouseover', onCardApproach, { passive: true });
  document.addEventListener('touchstart', onCardApproach, { passive: true });
  document.addEventListener('focusin', onCardApproach);

})();